import { ContainerDesktop } from "components/Container";
import Link from "next/link";
import React, { ReactNode, useState, useEffect, useRef } from "react";
import Button from "components/Button";
import { useAuthStore } from "modules/Auth/authStore";
import {
  SkeletonCircle,
  SkeletonRect,
  SkeletonWrapper,
} from "components/Skeleton/Skeleton";
import { trackEvent, trackEventGA, trackEventGTM } from "lib/amplitude";
import { useRouter } from "next/router";
import { useIsDesktop } from "lib/device";
import {
  getSubDomain,
  isBlueBirdURL,
  isBankingURL,
  isGokAresURL,
  isJambiURL,
  isMalukuURL,
  isMuaroJambiURL,
  isPesawaranURL,
  isTrenggalekURL,
  useIsSubdomain,
  useIsTenant,
  isSubdomainBluebird,
  isInjourneyURL,
  isSubdomainMgmBosco,
  isMgmBoscoURL,
} from "lib/host";
import InstantSearchBox from "components/InstantSearchBox/InstantSearchBox";
import useTranslation from "next-translate/useTranslation";
import Images from "next/image";
import { NotificationComponent } from "modules/Notification";
import { isBrowser } from "lib/ssr";
import { generateIndexName } from "lib/algolia";
import { HomeHeader } from "modules/Home/HomeHeader";
import { CONST } from "lib/const";
import ToggleDarkMode from "components/Form/ToggleDarkMode";
import { useSystemStore } from "./systemStore";
import { useModalStore } from "components/Modal/modalStore";
import { useSearchStore } from "components/InstantSearchBox/searchStore";
import { useTabsStore } from "components/Tabs/tabsStore";
import { getCookie } from "lib/helper";
// import PoinChip from "components/Chip/PoinChip";
import Image from "next/image";
import IconUser from "components/Icon/IconUser";
import { IconStatus } from "components/Icon/IconStatus";
import { IconLock } from "components/Icon/IconLock";
import IconSignOutAlt from "components/Icon/IconSignOutAlt";
import IconApperance from "components/Icon/IconApperance";
import JpChip from "components/Chip/JpChip";
import { HomeLogo } from "modules/Home/HomeLogo";
import PoinChip from "components/Chip/PoinChip";
import { useDeviceDetect } from "lib/detectDeviceV2";
import IconRecord from "components/Icon/IconRecord";
import { useAvatarStore } from "components/InteractiveAvatar/avatarStore";

const menus = [
  // {
  //   href: {
  //     pathname: "/",
  //   },
  //   text: "Home",
  // },
  {
    href: {
      //@ts-ignore
      pathname: "/explore",
    },
    text: "Eksplor",
  },
  {
    href: {
      pathname: "/my-class",
    },
    text: "Kelas Saya",
  },
  // {
  //   href: {
  //     pathname: "#courses",
  //   },
  //   text: "Kursus",
  // },
  // {
  //   href: {
  //     pathname: "/downloads",
  //   },
  //   text: "Downloads",
  // },
  {
    //@ts-ignore
    href: "https://learnext.ai?utm_source=learnext&utm_medium=textlink-header",
    text: "Learnext Business",
  },
];

const newMenus = [
  // {
  //   href: {
  //     pathname: "/",
  //   },
  //   text: "Home",
  // },
  {
    href: {
      //@ts-ignore
      pathname: "/explore",
    },
    text: "Eksplor",
  },
  {
    href: {
      pathname: "/my-class",
    },
    text: "Kelas Saya",
  },
  // {
  //   href: {
  //     pathname: "#courses",
  //   },
  //   text: "Kursus",
  // },
  {
    href: {
      pathname: "/dashboard",
    },
    text: "Dashboard",
  },
  // {
  //   href: {
  //     pathname: "/downloads",
  //   },
  //   text: "Downloads",
  // },
  {
    //@ts-ignore
    href: "https://learnext.ai?utm_source=learnext&utm_medium=textlink-header",
    text: "Learnext Business",
  },
];

const useOutsideClick = (callback: () => void) => {
  const ref = React.useRef();

  React.useEffect(() => {
    const handleClick = (event: any) => {
      if (ref.current && !(ref.current as any)?.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener("click", handleClick, true);

    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, [ref]);

  return ref;
};

export const PageHeaderDesktop: React.FC<{
  headerRef?: any;
  children?: ReactNode;
  isTransparent?: boolean;
  hideSearchbar?: boolean;
  onChangeSearch?: () => void;
}> = ({
  headerRef,
  children,
  isTransparent,
  onChangeSearch,
  hideSearchbar = false,
}) => {
  const { loginState, currentUser } = useAuthStore((state) => ({
    loginState: state.loginState,
    currentUser: state.currentUser,
  }));
  const [theme] = useSystemStore((state) => [state.theme]);
  const isSubdomainTenant = useIsSubdomain();
  const isB2B = useIsSubdomain() || useIsTenant();
  const router = useRouter();
  const isLMS = router.pathname.includes("/course/[courseSlug]");
  const [LINKS, setLinks] = useState([]);
  const { indexName, setIndexName } = useSearchStore();
  const [showLeaderboard, setShowLeaderboard] = useState(false);

  // Device hook
  const { isMobile, isTablet, isDesktop, isPortrait, width, height } =
    useDeviceDetect();

  const isGokAresTenant =
    typeof window !== "undefined" && isGokAresURL(window.location.hostname);
  const isInJourneyTenant =
    typeof window !== "undefined" && isInjourneyURL(window.location.hostname);

  const tenantJpTracker =
    (currentUser?.tenant !== undefined &&
      [
        "ppsdmaparatur",
        "menpan",
        "wonderfullearning",
        "kemkes",
        "tapinkab",
        "bssn",
        "bkpsdm-bekasikota",
        // "maluku-gate",
        // "trenggalekkab",
        "bpsdm-sumbar",
        "bpsdm-sulsel",
        "bpsdm-jambi",
        "bpsdmdki",
        // "jambikota",
        // "muarojambikab",
        // "pesawarankab",
        "batam",
        "pusdiklat-komdigi",
        "pusdiklat-kemenkeu",
        "kemenperin",
        "kemenlh",
        "setneg",
        "kemlu",
        "Kemendag",
        "ekraf",
        "bappenas",
        "kemensos",
        "kemendagri",
        "kominfo",
        "kemendes",
        "kemenpora",
        "kemenpppa",
        "kementan",
        "kudagang",
        "atrbpn",
      ].includes((currentUser?.tenant as any)?.slug)) ||
    [
      "ppsdmaparatur",
      "menpan",
      "wonderfullearning",
      "kemkes",
      "tapinkab",
      "bssn",
      "bkpsdm-bekasikota",
      // "maluku-gate",
      // "trenggalekkab",
      "bpsdm-sumbar",
      "bpsdm-sulsel",
      "bpsdm-jambi",
      "bpsdmdki",
      // "jambikota",
      // "muarojambikab",
      // "pesawarankab",
      "batam",
      "pusdiklat-komdigi",
      "pusdiklat-kemenkeu",
      "kemenperin",
      "kemenlh",
      "setneg",
      "kemlu",
      "Kemendag",
      "ekraf",
      "bappenas",
      "kemensos",
      "kemendagri",
      "kominfo",
      "kemendes",
      "kemenpora",
      "kemenpppa",
      "kementan",
      "kudagang",
      "atrbpn",
    ].includes(currentUser?.referral);

  // Allowing list of client to show leaderboard
  const clientLeaderboards = [
    "kemenperin",
    "demoplus",
    "umkm",
    "desa",
    "wonderfullearning",
    "kapalapi",
    "ppsdmaparatur",
    "kemkes",
    // "bluebird",
  ];

  const subDomain = isBrowser() ? getSubDomain(window.location.hostname) : null;
  const isTenantURL = useIsTenant();
  const { isShowModal } = useModalStore();

  // Condition for wavemaker
  const isShowLanguageToggle = subDomain == "wavemaker" ? true : false;

  useEffect(() => {
    let isAdmin = currentUser && currentUser?.role === "Tenant Admin";
    let isKemlu = currentUser && currentUser?.referral === "kemlu";

    setLinks(newMenus);
    // if (currentUser && isB2B && (isAdmin || isKemlu)) {
    //   setLinks(newMenus);
    // } else {
    //   setLinks(menus);
    // }
  }, [isSubdomainTenant, currentUser, isTenantURL]);

  const referralCode =
    getCookie("ref_code_gk") && getCookie("ref_code_gk") !== "null"
      ? getCookie("ref_code_gk")
      : typeof window !== "undefined"
      ? new URLSearchParams(window.location.search).get("referral")
      : "";

  useEffect(() => {
    let nameOfIndex;

    if (loginState === "LOGIN" && currentUser) {
      if (
        currentUser?.referral.includes("gaji-c") &&
        currentUser?.referral != "gaji-c0000117"
      ) {
        nameOfIndex = generateIndexName("gaji");
      } else if (
        currentUser?.referral.includes("gaji-c") &&
        currentUser?.referral == "gaji-c0000117"
      ) {
        nameOfIndex = generateIndexName(currentUser?.referral);
      } else {
        nameOfIndex = generateIndexName(
          window.location.hostname === "e-learning.bluebirdgroup.com"
            ? "bluebird"
            : window.location.hostname === "lms.injourney.id"
            ? "injourney"
            : currentUser?.referral == "bssn"
            ? "tapinkab"
            : window.location.hostname === "mgmbosco.learnext.ai"
            ? "gaji-c0000756"
            : currentUser?.referral
        );
      }
      setIndexName(nameOfIndex);
      /// Show Leaderboard for freetrial & clientLeaderboards & dev only
      if (
        currentUser?.tenant?.status === "Trial" ||
        clientLeaderboards.includes(currentUser?.referral) ||
        CONST.IS_DEV ||
        (isB2B && currentUser?.referral !== "bluebird")
      ) {
        setShowLeaderboard(true);
      }
    } else {
      const nameOfIndex = generateIndexName(
        window.location.hostname === "e-learning.bluebirdgroup.com"
          ? "bluebird"
          : window.location.hostname === "lms.injourney.id"
          ? "injourney"
          : subDomain == "bssn"
          ? "tapinkab"
          : window.location.hostname === "mgmbosco.learnext.ai"
          ? "gaji-c0000756"
          : subDomain
      );
      setIndexName(nameOfIndex);
    }
  }, [currentUser, loginState, referralCode]);

  const labels = (a: any) => {
    let labelColor = {
      default: isTransparent ? "text-white" : "text-neutral80_to_dark10",
      selected: isTransparent
        ? "text-white"
        : "text-violet_main_to_dark_purple_surface",
    };

    return router.pathname == a ? labelColor.selected : labelColor.default;
  };

  const ref = useOutsideClick(() => {
    setIsShowPopupNotif(false);
  });

  const [dataDropdown, setDataDropdown] = useState([
    {
      id: 1,
      label: "Profil",
      icon: "user",
      href: "/account?id=profile",
    },
    {
      id: 2,
      label: "Status",
      icon: "status",
      href: "/account?id=status",
    },
    {
      id: 3,
      label: "Ganti Kata Sandi",
      icon: "lock",
      href: "/account?id=change-password",
    },
    {
      id: 54,
      label: "Keluar",
      icon: "sign-out",
      href: "/logout",
    },
  ]);

  const renderIcon = (icon: string) => {
    switch (icon) {
      case "user":
        return <IconUser className="fill-purple-80" />;
      case "status":
        return <IconStatus className="fill-purple-80" />;

      case "lock":
        return <IconLock className="fill-purple-80" />;

      case "sign-out":
        return <IconSignOutAlt className="fill-purple-80" />;

      case "apperance":
        return <IconApperance className="fill-purple-80" />;
      default:
        return <IconUser className="fill-purple-80" />;
    }
  };

  const timeoutRef = useRef(null);
  const [isShowed, setIsShowed] = useState(false);

  const handleMouseEnter = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsShowed(true);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsShowed(false);
    }, 200);
  };

  const renderUser = () => {
    switch (loginState) {
      case "IDLE":
      case "LOADING":
        return (
          <SkeletonWrapper>
            <SkeletonCircle size={32} />
          </SkeletonWrapper>
        );

      case "NOT_LOGIN":
        return (
          <Link
            href={{
              pathname: isB2B ? "/login" : "/register",
              query: {
                url: encodeURIComponent(router.asPath),
              },
            }}
            onClick={() => {
              trackEventGTM({
                event: "homepage_signup_a",
              });
            }}
          >
            <Button
              size={isB2B ? "medium" : isDesktop ? "large" : "small"}
              variant={isB2B ? "primary" : "secondary_white"}
              className="!border-[1px]"
            >
              {isB2B ? t("login") : t("register")}
            </Button>
          </Link>
        );
      case "LOGIN":
        const ButtonProfile = (
          <div className="relative">
            <div className="flex items-center justify-center">
              {(!isTenantURL || isSubdomainTenant) && (
                <div
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <Image
                    alt="profile"
                    src={"/images/profile.svg"}
                    width={24}
                    height={24}
                    className={theme === "dark" ? "invert brightness-0" : ""}
                  />
                </div>
              )}
            </div>

            {(!isTenantURL || isSubdomainTenant) && isShowed && (
              <div
                className="absolute min-w-[240px] flex flex-col p-[16px] right-0 top-[44px] z-10 mt-2 origin-top-right rounded-md bg-white_to_dark20 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                {dataDropdown &&
                  dataDropdown.length > 0 &&
                  dataDropdown.map((a, index) => (
                    <div
                      className="flex justify-between"
                      key={"DropdownSettings" + "-" + index}
                    >
                      <Link
                        legacyBehavior
                        // @ts-ignore
                        href={a.href || "#"}
                        passHref
                      >
                        <a
                          className="cursor-pointer py-16 text-b1 text-purple-80 font-light hover:font-medium flex items-center gap-8"
                          role="dropdownitem"
                          id={"DropdownSettings" + "-" + index}
                        >
                          {a.icon && <div>{renderIcon(a.icon)}</div>}
                          {a.label}
                        </a>
                      </Link>

                      {a.id == 4 && <ToggleDarkMode isSwitch={true} />}
                    </div>
                  ))}
              </div>
            )}
          </div>
        );
        return ButtonProfile;

      default:
        return <></>;
    }
  };

  const renderLeaderboard = () => {
    switch (loginState) {
      case "IDLE":
      case "NOT_LOGIN":
      case "LOADING":
        return (
          <SkeletonWrapper>
            <SkeletonCircle size={32} />
          </SkeletonWrapper>
        );
      case "LOGIN":
        return (
          <Link
            //@ts-ignore
            href={"/leaderboard"}
          >
            <div
              className={`cursor-pointer ${
                !(tenantJpTracker || isGokAresTenant) && "px-12 py-8"
              } rounded-8 flex gap-8 items-center justify-center text-b1 text-purple60_to_dark10 ${
                !(tenantJpTracker || isGokAresTenant) && "bg-purple05_to_dark80"
              }`}
            >
              {theme == "dark" && (
                <Images
                  src={"/images/leaderboard-dark-2.png"}
                  alt="leaderboard"
                  width={20}
                  height={20}
                />
              )}
              {theme == "light" && (
                <Images
                  src={"/images/leaderboard.png"}
                  alt="leaderboard"
                  width={20}
                  height={20}
                />
              )}

              {!(tenantJpTracker || isGokAresTenant) && (
                <p className="text-purple50_to_dark10">Leaderboard</p>
              )}
            </div>
          </Link>
        );
      default:
        return <></>;
    }
  };

  useEffect(() => {
    if (isShowLanguageToggle) {
      const { asPath, push } = router;
      // Change to English
      setTimeout(() => {
        // @ts-ignore
        push(asPath, undefined, { locale: "en" });
      }, 200);
    }
  }, [isShowLanguageToggle]);

  const [isShowPopupNotif, setIsShowPopupNotif] = useState(false);

  // only query on preview LMS on moodle to bottom tabs contents
  const usePreview = router?.query?.usePreview == "true";

  const trackNavbar = (type: string) => {
    trackEventGTM({
      event: "nav_a",
      property: {
        button_type: type,
        page: router.pathname,
      },
    });
  };
  const { t } = useTranslation("common");

  let placeHolder = "Ingin belajar apa hari ini?";
  if (isLMS)
    placeHolder = useIsTenant()
      ? t("searchCoursesTruncate")
      : t("searchCourses");

  // Desa configuration
  const isMalukuTenant =
    typeof window !== "undefined" && isMalukuURL(window.location.hostname);
  const isPesawaranTenant =
    typeof window !== "undefined" && isPesawaranURL(window.location.hostname);
  const isTrenggalekTenant =
    typeof window !== "undefined" && isTrenggalekURL(window.location.hostname);
  const isMuaroJambiTenant =
    typeof window !== "undefined" && isMuaroJambiURL(window.location.hostname);
  const isJambiKotaTenant =
    typeof window !== "undefined" && isJambiURL(window.location.hostname);

  const isBlueBirdTenant =
    typeof window !== "undefined" &&
    (isBlueBirdURL(window.location.hostname) ||
      isSubdomainBluebird(window.location.hostname) ||
      currentUser?.referral === "bluebird");

  const isMgmBoscoTenant =
    typeof window !== "undefined" &&
    (isMgmBoscoURL(window.location.hostname) ||
      isSubdomainMgmBosco(window.location.hostname));

  const isBankingTenant =
    typeof window !== "undefined" && isBankingURL(window.location.hostname);

  const { setSelectedTab } = useTabsStore();
  const { isRecordMode, setIsRecordMode } = useAvatarStore();

  const combineRefs = (element) => {
    if (headerRef) {
      headerRef.current = element;
    }
    ref.current = element;
  };

  return (
    <>
      {/* Desktop Layout */}
      {isDesktop && (
        <header
          ref={combineRefs}
          className={
            "w-full lg:z-10 md:z-10 sm:z-10 h-[68px] " +
            (isTransparent
              ? "bg-transparent fixed top-0 bg-header-pattern "
              : "bg-white border-b border-neutral20_to_dark30 sticky top-0 ")
          }
          style={{ zIndex: 50 }}
        >
          <ContainerDesktop
            className={"h-full md:flex items-center justify-between hidden"}
          >
            <div
              className={
                "flex items-center flex-shrink-0 " +
                (isTenantURL || isSubdomainTenant ? "w-[45%] " : "flex-1 ") +
                (showLeaderboard ? "" : "lg-max:w-[55%]")
              }
            >
              <Link
                // @ts-ignore
                href={!usePreview ? "/" : "#"}
                onClick={!usePreview ? () => trackNavbar(" Logo") : undefined}
              >
                <div className="pr-24 flex-shrink-0">
                  {isMalukuTenant ? (
                    <>
                      {theme == "light" && (
                        <Images
                          src={"/maluku/maluku-light.svg"}
                          alt="app"
                          width={122}
                          height={25}
                        />
                      )}
                      {theme == "dark" && (
                        <Images
                          src={"/maluku/maluku-dark.svg"}
                          alt="app"
                          width={122}
                          height={25}
                        />
                      )}
                    </>
                  ) : isPesawaranTenant ? (
                    <Images
                      src={
                        theme == "dark"
                          ? "/pesawaran/pesawaran-dark.svg"
                          : "/pesawaran/pesawaran-light.svg"
                      }
                      alt="app"
                      width={152}
                      height={25}
                    />
                  ) : isTrenggalekTenant ? (
                    <Images
                      src={
                        theme == "dark"
                          ? "/trenggalek/trenggalek-dark.svg"
                          : "/trenggalek/trenggalek-light.svg"
                      }
                      alt="app"
                      width={152}
                      height={25}
                    />
                  ) : isMuaroJambiTenant ? (
                    <Images
                      src={
                        theme == "dark"
                          ? "/muaro-jambi/muaro-jambi-dark.svg"
                          : "/muaro-jambi/muaro-jambi-light.svg"
                      }
                      alt="app"
                      width={152}
                      height={25}
                    />
                  ) : isJambiKotaTenant ? (
                    <Images
                      src={
                        theme == "dark"
                          ? "/jambi/jambi-dark.svg"
                          : "/jambi/jambi-light.svg"
                      }
                      alt="app"
                      width={96}
                      height={16}
                    />
                  ) : isBlueBirdTenant ? (
                    <Images
                      src={
                        theme == "dark"
                          ? "/images/logo-bluebird-dark.png"
                          : "/images/logo-bluebird-light.png"
                      }
                      alt="Blue Bird"
                      width={120}
                      height={27}
                    />
                  ) : isBankingTenant ? (
                    <Images
                      src={
                        theme == "dark"
                          ? "/images/logo-nxtx-dark.png"
                          : "/images/logo-nxtx-light.png"
                      }
                      alt="NXTX"
                      width={120}
                      height={19}
                    />
                  ) : subDomain == "alfamart" ||
                    currentUser?.referral == "alfamart" ? (
                    <HomeLogo />
                  ) : isInJourneyTenant ||
                    subDomain == "injourney" ||
                    currentUser?.referral == "injourney" ? (
                    <HomeLogo />
                  ) : (
                    <Images
                      src={
                        theme == "dark"
                          ? "/logo-white-2048.png"
                          : "/logo-2048.png"
                      }
                      alt="learnext"
                      width={120}
                      height={21}
                    />
                  )}
                </div>
              </Link>
              {!usePreview && (
                <div
                  className={
                    "flex items-center text-b1 font-medium " +
                    (isTransparent ? "text-white" : "text-neutral-80")
                  }
                >
                  {LINKS && LINKS.length
                    ? LINKS.filter((a) =>
                        isTenantURL || isSubdomainTenant
                          ? !["Eksplor", "Learnext Business"].includes(a.text)
                          : a
                      ).map((l, i) => {
                        if (l.text.includes("Business")) {
                          return (
                            <a
                              key={i}
                              target="__blank"
                              //@ts-ignore
                              href={l.href}
                              onClick={() => trackNavbar(l.text)}
                              rel="noopener noreferrer"
                            >
                              <div
                                className={
                                  "whitespace-nowrap p-12 flex relative items-center " +
                                  labels(l.href.pathname)
                                }
                              >
                                <h5>{l.text}</h5>
                                <div className="absolute text-c2 bg-orange-50 text-white rounded-4 px-6 py-2 right-[-30px]">
                                  <p>NEW</p>
                                </div>
                              </div>
                            </a>
                          );
                        } else if (l.text == "Kelas Saya") {
                          return (
                            <h5
                              onClick={() => {
                                if (loginState !== "LOGIN" && !isTenantURL) {
                                  router.push("/login");
                                } else {
                                  setSelectedTab({
                                    id: "di-pelajari",
                                    label: "Dipelajari",
                                    title: "Lanjutkan Kursusmu",
                                    value: "on_progress",
                                  });

                                  router.replace({
                                    pathname: "/my-class",
                                    query: {
                                      tabId: "di-pelajari",
                                    },
                                  });
                                }
                              }}
                              className={
                                "whitespace-nowrap p-12 cursor-pointer " +
                                labels(l.href.pathname)
                              }
                            >
                              {t(l.text)}
                            </h5>
                          );
                        } else if (l.text === "Kursus") {
                          const scrollTo = (id: string) => {
                            const element = document.getElementById(id);
                            if (element) {
                              const elementPosition =
                                element.getBoundingClientRect().top +
                                window.scrollY;
                              const offset = 70;

                              window.scrollTo({
                                top: elementPosition - offset,
                                behavior: "smooth",
                              });
                            }
                          };

                          const handleScroll = () => {
                            const { pathname } = router;

                            if (pathname !== "/") {
                              router.push("/").then(() => {
                                scrollTo("courses");
                                setTimeout(() => {
                                  scrollTo("corses");
                                }, 300);
                              });
                            } else {
                              scrollTo("courses");
                              setTimeout(() => {
                                scrollTo("courses");
                              }, 300);
                            }
                          };

                          return (
                            <div onClick={handleScroll}>
                              <h5
                                className={
                                  "cursor-pointer p-12 " +
                                  labels(l.href.pathname)
                                }
                              >
                                {t(l.text)}
                              </h5>
                            </div>
                          );
                        } else {
                          return (
                            <Link
                              key={i}
                              //@ts-ignore
                              href={l.href}
                              onClick={() => trackNavbar(l.text)}
                            >
                              <h5 className={"p-12 " + labels(l.href.pathname)}>
                                {t(l.text)}
                              </h5>
                            </Link>
                          );
                        }
                      })
                    : null}
                  <span className="text-[#E5E7EB]">|</span>
                  <div
                    onClick={() => {
                      if (isRecordMode) return;
                      setIsRecordMode(true);
                    }}
                    className="cursor-pointer flex items-center gap-8 ml-12 rounded-32"
                  >
                    <IconRecord />
                    <h5>Coach Nexa</h5>
                  </div>
                </div>
              )}
            </div>
            <div
              className={
                " " +
                (isTenantURL || isSubdomainTenant ? "w-[55%] " : "flex-1 ") +
                (showLeaderboard ? "" : "lg-max:w-[55%]")
              }
            >
              {children ? (
                children
              ) : isTenantURL || isSubdomainTenant ? (
                loginState == "LOGIN" ? (
                  <div className="flex justify-end items-center gap-16">
                    {indexName && (
                      <InstantSearchBox
                        indexName={indexName}
                        placeholder={
                          // useIsTenant()
                          //   ? t("searchCoursesTruncate")
                          //   : t("searchCourses")
                          "Cari"
                        }
                        position="right"
                        className="w-[30vw] xl:w-[30vw] lg-max:w-[15vw] px-16"
                        events={{
                          event: "b2b_searchbar_start_a",
                          property: {
                            page: `B2B Homepage`,
                          },
                        }}
                      />
                    )}

                    {(tenantJpTracker || isGokAresTenant) && <JpChip />}

                    {/* {showLeaderboard ? renderLeaderboard() : null} */}

                    {/* <InputSwitch
                    id="toggle_tenant"
                    onChange={changeLanguage}
                    className="mr-8"
                    //@ts-ignore
                    selected={locale.toUpperCase()}
                    otherValue={otherLocale.toUpperCase()}
                  /> */}

                    {currentUser?.referral !== "bluebird" &&
                      (currentUser?.referral === "nexa" ||
                        currentUser?.referral === "esdm-ares") && <PoinChip />}

                    <div className="w-[1.5px] h-[24px] rounded-[100px] bg-[#F2F2F3]"></div>

                    <NotificationComponent
                      isShowPopupNotif={isShowPopupNotif}
                      setIsShowPopupNotif={setIsShowPopupNotif}
                      isIconTransparent={theme !== "dark"}
                    />

                    <ToggleDarkMode isSwitch={true} />

                    {renderUser()}
                  </div>
                ) : (
                  <div className="flex justify-end items-center gap-16">
                    {indexName && (
                      <InstantSearchBox
                        indexName={indexName}
                        placeholder={
                          useIsTenant()
                            ? t("searchCoursesTruncate")
                            : t("searchCourses")
                        }
                        position="right"
                        className="w-600 x-max:w-400"
                        events={{
                          event: "b2b_searchbar_start_a",
                          property: {
                            page: `B2B Homepage`,
                          },
                        }}
                      />
                    )}
                    {renderUser()}
                  </div>
                )
              ) : (
                <div className="flex justify-end items-center gap-16">
                  <InstantSearchBox
                    placeholder={placeHolder}
                    position="right"
                    className="w-400 x-max:w-300"
                    events={{
                      event: "explore_searchbar_start_a",
                      property: {
                        page: router.pathname,
                      },
                    }}
                  />

                  {/* add load condition based on login state when rendering */}
                  {
                    {
                      LOGIN: (
                        <>
                          <NotificationComponent
                            isShowPopupNotif={isShowPopupNotif}
                            setIsShowPopupNotif={setIsShowPopupNotif}
                            isIconTransparent={theme !== "dark"}
                          />
                          {renderUser()}
                        </>
                      ),
                      LOADING: (
                        <SkeletonWrapper className="flex gap-16">
                          {[1, 2].map((el) => (
                            <SkeletonRect
                              key={el}
                              className="h-48 rounded-8 w-82"
                            />
                          ))}
                        </SkeletonWrapper>
                      ),
                      NOT_LOGIN: (
                        <>
                          <Link
                            href={{
                              pathname: "/login",
                              query: {
                                url: encodeURIComponent(router.asPath),
                              },
                            }}
                          >
                            <Button
                              variant={
                                isTransparent
                                  ? "white_transparant"
                                  : "secondary_transparant"
                              }
                              className={isTransparent ? "border-none" : ""}
                              isFull
                              size={isDesktop ? "large" : "small"}
                            >
                              {t("login")}
                            </Button>
                          </Link>
                          <Link href={"/register"}>
                            <Button
                              variant={
                                isTransparent ? "white_transparant" : "primary"
                              }
                              isFull
                              size={isDesktop ? "large" : "small"}
                            >
                              Daftar
                            </Button>
                          </Link>
                        </>
                      ),
                    }[loginState]
                  }
                </div>
              )}
            </div>
          </ContainerDesktop>
        </header>
      )}

      {/* Mobile Layout */}
      {(isTablet || isMobile) && (
        <>
          {!isLMS && (
            <header
              ref={combineRefs}
              className={
                "w-full z-30 h-[68px] p-16 " +
                (isTransparent
                  ? "bg-transparent fixed top-0 bg-header-pattern "
                  : "bg-white border-b border-neutral20_to_dark30 sticky top-0 ")
              }
              style={{ zIndex: isShowModal ? 30 : 20 }}
              // style={{ zIndex: 50 }}
            >
              <HomeHeader isTransparent={isTransparent} />
            </header>
          )}
        </>
      )}
    </>
  );
};
